<script>
    import { page } from '$app/stores';
    import { onMount } from 'svelte';
    import CityItem from './CityItem.svelte';
    import Button from '$lib/atoms/Button.svelte';
    import { t } from '$lib/i18n.js';
    import { Search } from 'lucide-svelte';

    let cities = [
        { name: 'bologna', image: "https://assets.auting.it/images/500/bologna.jpg" },
        { name: 'firenze', image: "https://assets.auting.it/images/500/firenze.jpg" },
        { name: 'cagliari', image: "https://assets.auting.it/images/500/cagliari.jpg" },
        { name: 'bari', image: "https://assets.auting.it/images/500/bari.jpg" },
        { name: 'roma', image: "https://assets.auting.it/images/500/roma.jpg" },
        { name: 'milano', image: "https://assets.auting.it/images/500/milano.jpg" },
        { name: 'palermo', image: "https://assets.auting.it/images/500/palermo.jpg" },
        { name: 'catania', image: "https://assets.auting.it/images/500/catania.jpg" }
    ];

    // Preload delle prime 4 immagini per migliori performance
    $: firstFourCities = cities.slice(0, 4);
    
    // Preload critical images that are above the fold
    onMount(() => {
        // Preload first 4 city images as they're likely above the fold
        firstFourCities.forEach(city => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.href = city.image;
            link.as = 'image';
            link.type = 'image/jpeg';
            document.head.appendChild(link);
        });
    });
</script>

<section>
    <div class="col">
        <h2>🔍<br/>{$t('cities.browse')}</h2>
        <div class="cars-grid">
            {#each cities as city, index}
                <CityItem 
                    name={$t(`cities.${city.name}`)}
                    image={city.image}
                    imageAlt={$t(`cities.${city.name}`)}
                    link={$t(`cities.links.${city.name}`)}
                    priority={index < 4} />
            {/each}
            
        </div>
        <Button 
            icon={Search}
            href="/{$page.params.lang}/#search"
            style="margin-top: 24px;"
            textColor="var(--on-primary)"
            label="{$t('routes.home.cities.cta')}" />
    </div>
</section>

<style>
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 24px;
                padding: 1rem 2rem;

        padding-top: 100px;
        padding-bottom: 120px;
    }

    .col {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: var(--max-width);
        
    }

    .cars-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
        width: 100%;
        max-width: var(--max-width);
        margin-bottom: 40px;
    }

    h2 {
        text-align: center;
    }

    @media (max-width: 768px) {
        section {
            align-items: center;
            padding: 1rem;
            padding-top: 120px;
        }
        .cars-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
        }
    }
</style>